import Module, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import BullBullMatchView from "./bullbull_match_view";
import BullBullConst from "../utils/bullbull_const";
import TableMatchModule from "../../../table/module/table_match/table_match_module";


const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit(BullBullConst.MATCH_MODULE_NAME)
export default class BullBullMatchModule extends TableMatchModule<BullBullMatchView> {

    constructor(){
        super();

        //this.layer = ViewLayer.High;
        //this.viewType = BullBullMatchView;
        //this.modelType = null;
        //this.windowPrefabResPath = BullBullConst.PREFAB_RES_PATH_BASE + "bullbull_tip";
    }

    onLoad()
    {
    }

    // public onButtonClickName(name : string){

    //     switch (name) {
    //         case "CloseBtn":               
    //             super.onButtonClickName(name);                                
    //         break;                    
    //     }
    // }

    onShow(intentData? : any){
                
        super.onShow(intentData);       

    }

    protected refreshPlayer( userId : number | Long , seatId : number | Long){

        super.refreshPlayer( userId , seatId);

        
        
    }

}
